"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReclaimProductRequestPayloadReclamationReasonEnum = exports.ReclaimProductRequestPayloadToJSON = exports.ReclaimProductRequestPayloadFromJSONTyped = exports.ReclaimProductRequestPayloadFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function ReclaimProductRequestPayloadFromJSON(json) {
    return ReclaimProductRequestPayloadFromJSONTyped(json, false);
}
exports.ReclaimProductRequestPayloadFromJSON = ReclaimProductRequestPayloadFromJSON;
function ReclaimProductRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'invoiceNumber': !(0, runtime_1.exists)(json, 'invoiceNumber') ? undefined : json['invoiceNumber'],
        'invoiceDate': !(0, runtime_1.exists)(json, 'invoiceDate') ? undefined : json['invoiceDate'],
        'orderId': !(0, runtime_1.exists)(json, 'orderId') ? undefined : json['orderId'],
        'articleNumber': json['articleNumber'],
        'articleDescription': json['articleDescription'],
        'customerNo': json['customerNo'],
        'emailAddress': json['emailAddress'],
        'primaryPhoneNumber': !(0, runtime_1.exists)(json, 'primaryPhoneNumber') ? undefined : json['primaryPhoneNumber'],
        'billingAddress': (0, _1.ReclaimAddressFromJSON)(json['billingAddress']),
        'shippingAddress': (0, _1.ReclaimAddressFromJSON)(json['shippingAddress']),
        'reclamationReason': !(0, runtime_1.exists)(json, 'reclamationReason') ? undefined : json['reclamationReason'],
        'reclamationDescription': json['reclamationDescription'],
        'replacementNumber': !(0, runtime_1.exists)(json, 'replacementNumber') ? undefined : json['replacementNumber'],
        'dataTypeShield': !(0, runtime_1.exists)(json, 'dataTypeShield') ? undefined : json['dataTypeShield'],
        'bestReachedPhoneNumber': !(0, runtime_1.exists)(json, 'bestReachedPhoneNumber') ? undefined : json['bestReachedPhoneNumber'],
        'contactBy': !(0, runtime_1.exists)(json, 'contactBy') ? undefined : json['contactBy'],
    };
}
exports.ReclaimProductRequestPayloadFromJSONTyped = ReclaimProductRequestPayloadFromJSONTyped;
function ReclaimProductRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'invoiceNumber': value.invoiceNumber,
        'invoiceDate': value.invoiceDate,
        'orderId': value.orderId,
        'articleNumber': value.articleNumber,
        'articleDescription': value.articleDescription,
        'customerNo': value.customerNo,
        'emailAddress': value.emailAddress,
        'primaryPhoneNumber': value.primaryPhoneNumber,
        'billingAddress': (0, _1.ReclaimAddressToJSON)(value.billingAddress),
        'shippingAddress': (0, _1.ReclaimAddressToJSON)(value.shippingAddress),
        'reclamationReason': value.reclamationReason,
        'reclamationDescription': value.reclamationDescription,
        'replacementNumber': value.replacementNumber,
        'dataTypeShield': value.dataTypeShield,
        'bestReachedPhoneNumber': value.bestReachedPhoneNumber,
        'contactBy': value.contactBy,
    };
}
exports.ReclaimProductRequestPayloadToJSON = ReclaimProductRequestPayloadToJSON;
/**
* @export
* @enum {string}
*/
var ReclaimProductRequestPayloadReclamationReasonEnum;
(function (ReclaimProductRequestPayloadReclamationReasonEnum) {
    ReclaimProductRequestPayloadReclamationReasonEnum["Incomplete"] = "incomplete";
    ReclaimProductRequestPayloadReclamationReasonEnum["Damaged"] = "damaged";
    ReclaimProductRequestPayloadReclamationReasonEnum["WrongProduct"] = "wrongProduct";
    ReclaimProductRequestPayloadReclamationReasonEnum["WrongPrice"] = "wrongPrice";
    ReclaimProductRequestPayloadReclamationReasonEnum["Other"] = "other";
})(ReclaimProductRequestPayloadReclamationReasonEnum = exports.ReclaimProductRequestPayloadReclamationReasonEnum || (exports.ReclaimProductRequestPayloadReclamationReasonEnum = {}));
//# sourceMappingURL=ReclaimProductRequestPayload.js.map